import { render, staticRenderFns } from "./RunningHourGOH.vue?vue&type=template&id=3dc9c6d1&scoped=true"
import script from "./RunningHourGOH.vue?vue&type=script&lang=js"
export * from "./RunningHourGOH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc9c6d1",
  null
  
)

export default component.exports